export default "__VITE_ASSET__C9CDZ1Iv__"